import { FC, useEffect } from "react";
import { BookingDataType, BookingStay, isStay } from "data/interfaces";
import InRequestWindowPanel from "./InRequestWindowPanel";

interface Props {
  booking: BookingDataType;
  onRemove: (item: BookingDataType) => void;
  onProblematicChange: (id: string | number, isProblematic: boolean) => void;
}

/**
 * Shows a warning panel when a stay marked as "only_in_package" has been
 * added to the cart by itself (not as part of a holiday package).
 *
 * The parent (SummaryStep / MyTripPage) uses the callback to drive a
 * "Continue" gate, preventing checkout until the item is removed.
 */
const OnlyInPackageStayGuard: FC<Props> = ({
  booking,
  onRemove,
  onProblematicChange,
}) => {
  const isStayBooking = isStay(booking.item);
  const stayBooking = isStayBooking ? (booking as BookingStay) : null;
  const isOnlyInPackage = !!(stayBooking?.item?.only_in_package);

  useEffect(() => {
    if (!stayBooking) return;
    onProblematicChange(stayBooking.id, isOnlyInPackage);
    return () => onProblematicChange(stayBooking.id, false);
  }, [isOnlyInPackage, stayBooking, onProblematicChange]);

  if (!stayBooking || !isOnlyInPackage) {
    return null;
  }

  return (
    <InRequestWindowPanel
      item={stayBooking}
      onSendRequest={() => {}}
      onRemove={onRemove}
      onChangeDates={() => {}}
      isLoading={false}
    />
  );
};

export default OnlyInPackageStayGuard;
